import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import GmapVue from 'gmap-vue'

Vue.config.productionTip = false
Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyDWSCsfUZYAXF8iQCKs4E9_J68JNqwvX3U',
    libraries: 'drawing,places',
  },
  // Demonstrating how we can customize the name of the components
  installComponents: true,
});

axios.interceptors.request.use(function (config: any) {
  config.headers = { Authorization: `Bearer ${ localStorage.getItem('token')}`, 'Accept': 'application/json'}
  return config;
}, function (error: any) {
  // Do something with request error
  return Promise.reject(error);
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
